import { render } from "./CharacterSheet.vue?vue&type=template&id=2e9079d4&scoped=true"
import script from "./CharacterSheet.vue?vue&type=script&lang=js"
export * from "./CharacterSheet.vue?vue&type=script&lang=js"

import "./CharacterSheet.vue?vue&type=style&index=0&id=2e9079d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e9079d4"]])

export default __exports__